import {
  Box,
  Loader,
  Center,
  Button,
  Flex,
  Grid,
  Input,
  Paper,
  Select,
  Text,
  Title,
  createStyles,
} from "@mantine/core";

import fetchResourceIcon from "../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";
import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import calendarSvg from "../../assets/img/calendar.svg";

import { DateInput, DateValue } from "@mantine/dates";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useMedplum } from "@medplum/react";
import { getPatientList, getPayerList, getProviderList, getRelatedPersonList, submitFormData, updatePatient, updateProvider } from "./EligibiltyService"
import { serviceTypeMap, locationMap } from "./EligibilityDataMap";
import GenericInfoModal from "../../components/GenericInfoModal";
import { ServiceTag } from "./ServiceTag";




const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",

    padding: "16px",
    marginTop: "16px",
  },
  Box1: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  title1: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
    // marginLeft: "50px",
  },
  box: {
    // gap: '10px',
    // marginInline: "20px",
    paddingInline: "16px",
    paddingBlock: "12px",
    borderWidth: "1px",
    borderStyle: 'solid',
    borderColor: "#F5F5F5",
    borderRadius: "6px",
    backgroundColor: "#FBFBFB",
  },
  cancel: {
    color: "black",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  create: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  descrption: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    marginBottom: "5px",
  },
  textarea: {
    height: "168px",
    width: "100%",
    padding: "16px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    border: "1px solid #E5E5E5",
    outline: "none",
    resize: "none",
    borderRadius: "8px",
    wordBreak: "break-word",
  },
  breadCrumbs: {
    marginBottom: "16px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
 
}));

export const NewEligibility = () => {
  const medplum = useMedplum();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const service = query.get("service") as 'pverify' | 'availity';
  const selectedServiceTypeMap = useRef(serviceTypeMap(service)).current;
  const modalSteps = [
    { loadText: "Fetching Details", label: "Fetch Details", icon: fetchResourceIcon },
    { loadText: "Generating Coverage Request", label: "Generate Coverage Request", icon: fetchResourceIcon },
    { loadText: `Requesting to ${service === 'pverify' ? 'Pverify' : 'Availity'}`, label: `Request to ${service === 'pverify' ? 'Pverify' : 'Availity'}`, icon: fetchResourceIcon },
    { loadText: "Converting to FHIR", label: "Convert to FHIR", icon: fetchResourceIcon },
    { loadText: "Updating Coverage", label: "Update Coverage", icon: fetchResourceIcon },
    { loadText: "Storing in HealthConnect", label: "Store in HealthConnect", icon: dbStoringIcon },
  ];



  const initForm = {
    subscriber: {
      id: "",
      lastName: "",
      name: "",
      memberId: "",
      birthDate: null as DateValue,
    },
    dependent: {
      id: "",
      name: "",
      birthDate: null as DateValue,
    },
    payer: {
      id: "",
    },
    provider: {
      id: "",
      name: "",
      npi: "",
      // groupNpi: "",
    },
    serviceType: {
      id: "",
    },
    miscellaneous: {
      fromDate: null as DateValue,
      toDate: null as DateValue,
      mrnAccount: "",
      placeOfService: "",
    },
  }

  const [subscriberList, setSubscriberList] = useState<any>([]);
  const [patientList, setPatientList] = useState<any>([]);
  const [payerList, setPayerList] = useState<any>([]);
  const [providerList, setProviderList] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [verificationType, setVerificationType] = useState('Self')
  const [error, setError] = useState<any>(null);
  const [formData, setFormData] = useState(initForm);
  const [showInfoModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    confirmText: "Request and Save Eligibility Summary",
    details: [],
    onClose: () => { },
    onConfirm: () => { },
  })

  useEffect(() => {
    Promise.all([
      //getRelatedPersonList(medplum).then((data: any) => setPatientList(data)),
      getPatientList(medplum).then((data: any) => setSubscriberList(data)),
      getPayerList(medplum, service).then((data: any) => setPayerList(data)),
      getProviderList(medplum).then((data: any) => setProviderList(data)),
    ]).then(() => {
      setIsFetching(false);
    });
  }, []);



  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let valid = true
    setError(null);

    const form = { ...formData }; // copy formData
    if (formData.provider.npi.length != 10) {
      setError({ ...error, npi: 'NPI should be 10 digits' });
      valid = false
    }

    const details: any = [
      {
        label: 'Birth Date', text: verificationType === "Self"
          ? formData.subscriber.birthDate?.toLocaleDateString() :
          formData.dependent.birthDate?.toLocaleDateString()
      },
      { label: 'Provider', text: formData.provider.name },
      { label: 'Payer', text: payerList.find((pv: any) => pv.value === form.payer.id)?.label },
      { label: 'Service Type', text: selectedServiceTypeMap.find((pv: any) => pv.value === form.serviceType.id)?.label },
      { label: 'Location', text: form.miscellaneous.placeOfService },
    ];

    if (valid) {

      //Check and update patient birth date
      if (verificationType === "Self") {
        if (formData.subscriber.birthDate?.toISOString().split('T')[0] != subscriberList.find((sub: any) => sub.id === form.subscriber.id).birthDate)
          updatePatient(medplum, form.subscriber);
      } else {
        if (formData.dependent.birthDate?.toISOString().split('T')[0] != patientList.find((sub: any) => sub.id === form.dependent.id).birthDate)
          updatePatient(medplum, form.dependent);
      }

      //Update NPI 
      if (formData.provider.npi != providerList.find((sub: any) => sub.id === form.provider.id)?.npi)
        updateProvider(medplum, form.provider);

      setModalData({
        ...modalData,
        title: verificationType === "Self" ? formData.subscriber.name : formData.dependent.name,
        sideTitle: verificationType,
        details: details,
        onClose: () => { },
        onConfirm: () => {
          setIsFetching(true);
          submitFormData(medplum, form, verificationType, service).then((data: any) => {
            setModalData((prevData: any) => ({
              ...prevData,
              onClose: () => navigate(`/admin/insurance/eligibility/details?id=${data.id ?? data.body.id}`)
            }));
          });
        },
      })

      setShowModal(true);

    }

  }

  const setVT = (val: string) => {
    setVerificationType(val);
    setFormData({
      ...formData,
      subscriber: {
        id: "",
        name: "",
        lastName: "",
        memberId: "",
        birthDate: null as DateValue,
      },
      dependent: {
        id: "",
        name: "",
        birthDate: null as DateValue,
      },
    })

    if (val === "Dependent") {
      setPatientList(subscriberList);
      setSubscriberList([]);
    }
    else if (val === "Self") setSubscriberList(patientList)
  }

  const setSubsciber = async (id: string) => {
    const subsData = subscriberList.find((res: any) => res.id === id);
    const formdata = {
      ...formData,
      subscriber: {
        id: subsData?.value,
        lastName: subsData?.lastName,
        name: subsData?.name,
        memberId: subsData?.memberId ?? '',
        birthDate: subsData?.birthDate ? new Date(subsData?.birthDate) : null
      }
    }
    setFormData(formdata);
  }

  const setPatient = async (id: string) => {
    const patientData = patientList.find((res: any) => res.id === id);
    getRelatedPersonList(medplum, patientData?.value).then((data: any) => setSubscriberList(data));
    const formdata = {
      ...formData,
      dependent: {
        id: patientData?.value,
        name: patientData?.name,
        birthDate: patientData?.birthDate ? new Date(patientData?.birthDate) : null
      }
    }
    setFormData(formdata);
  }


  const setDate = (val: DateValue, name: string) => {
    let formdata = { ...formData };
    if (name === "fromDate") {
      formdata.miscellaneous.fromDate = val
    } else if (name === "toDate") {
      formdata.miscellaneous.toDate = val
    } else if (name === "subscriberDate") {
      formData.subscriber.birthDate = val
    } else if (name === "dependentDate") {
      formdata.dependent.birthDate = val
    }

    setFormData(formdata);
  }

  const setProvider = (val: string) => {
    const providerData = providerList.find((pv: any) => pv.value === val);

    const formdata = {
      ...formData,
      provider: {
        id: val,
        name: providerData?.label,
        npi: providerData?.npi ?? '',
      }
    }
    setFormData(formdata);
  }

  const rightsection =
    <img
      src={calendarSvg}
      style={{
        width: 15,
        height: 15,
        color: "#666",
        cursor: "pointer",
      }}
    />

  return (
    <>
      {isFetching ? (
        <Center className={classes.loader}>
          <Loader />
        </Center>
      ) : (
        <form onSubmit={handleSubmit} >
          <Paper className={classes.default}>
            <Box sx={{}}>
              <Box className={classes.Box1}>
                <Box className={classes.breadCrumbs}>
                  <CustomBreadcrumbs />
                  <ServiceTag serviceType={service} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Title className={classes.title1}>New eligibility</Title>
                  <Select
                    width={250}
                    height={44}
                    placeholder=""
                    searchable
                    defaultValue={"Self"}
                    nothingFound="No options"
                    data={["Self", "Dependent"]}
                    onChange={(val: string) => setVT(val)}
                    required={true}
                  />
                </Box>
                {verificationType === "Dependent" ? <Box className={classes.box}>
                  {/* Dependent */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Dependent
                  </Text>
                  <Grid>
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Dependent Name
                      </Text>
                      <Select
                        placeholder="Enter Name"
                        searchable
                        required={true}
                        nothingFound="Nothing found"
                        data={patientList}
                        onChange={setPatient}
                        value={formData.dependent.id}
                      />{" "}

                    </Grid.Col>
                    {/* <Grid.Col md={6} lg={3}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Dependent Last name
                      </Text>
                      <Input<any> placeholder="Enter last name" />
                    </Grid.Col> */}
                    <Grid.Col md={6} lg={6} >
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Date of Birth
                      </Text>
                      <DateInput
                        // value={[]}
                        // onChange={setValue}
                        placeholder="mm/dd/yyyy"
                        // maw={600}
                        mx="auto"
                        rightSection={rightsection}
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        required={true}
                        value={formData.dependent.birthDate}
                        onChange={(val: DateValue) => setDate(val, 'dependentDate')}
                      />{" "}
                    </Grid.Col>
                  </Grid>
                </Box> : null}
                <Box className={classes.box}>
                  {/* Subscriber */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Subscriber
                  </Text>
                  <Grid >
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Subscriber Name
                      </Text>
                      {/* <Input<any> placeholder="Enter Name" /> */}
                      <Select
                        placeholder="Enter Name"
                        searchable
                        required={true}
                        nothingFound="Nothing found"
                        data={subscriberList}
                        onChange={setSubsciber}
                        value={formData.subscriber.id}
                      />{" "}

                    </Grid.Col>
                    {/* <Grid.Col md={6} lg={3}>
                  <Text size={14} weight={600} color="#262930" pb={5}>
                    Subscriber Last name
                  </Text>
                  <Input<any> required={true} value={formData.subscriber.lastName} placeholder="Enter last name" />
                </Grid.Col> */}

                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Member ID
                      </Text>
                      <Input<any> type="number"
                        required={true}
                        value={formData.subscriber.memberId}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                        onChange={(e: any) => setFormData({ ...formData, subscriber: { ...formData.subscriber, memberId: e.target.value } })}
                        placeholder="Enter member id" />
                    </Grid.Col>
                    </Grid>
                    {verificationType === "Self" ? <Grid><Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Date of Birth
                      </Text>
                      <DateInput
                        // value={[]}
                        // onChange={setValue}
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        required={verificationType === "Self"}
                        placeholder="mm/dd/yyyy"
                        onChange={(val: DateValue) => setDate(val, 'subscriberDate')}
                        // maw={600}
                        mx="auto"
                        rightSection={rightsection}
                        value={formData.subscriber.birthDate}
                      />{" "}
                  
                    </Grid.Col> </Grid>: null}
                </Box>
                <Box className={classes.box}>
                  {/* payer */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Payer
                  </Text>
                  <Grid>
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Payer Name
                      </Text>
                      {/* <Input<any> placeholder="Enter Payer name" />
                     */}
                      <Select 
                        placeholder="Enter Name"
                        searchable
                        required={true}
                        nothingFound="Nothing found"
                        data={payerList}
                        onChange={(id) => setFormData({ ...formData, payer: { id: id ?? '' } })}
                        value={formData.payer.id}
                      />{" "}

                    </Grid.Col>

                  </Grid>
                </Box>
                <Box className={classes.box}>
                  {/* Provider */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Provider
                  </Text>
                  <Grid>
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Provider Name
                      </Text>
                      <Select
                        placeholder="Select Provider"
                        searchable
                        required={true}
                        nothingFound="Nothing found"
                        data={providerList}
                        onChange={setProvider}
                        value={formData.provider.id}
                      />{" "}
                    </Grid.Col>
                    {/* <Grid.Col md={6} lg={3}>
                    <Text size={14} weight={600} color="#262930" pb={5}>
                      First name
                    </Text>
                    <Input<any> placeholder="Enter first name" />
                  </Grid.Col>
                  <Grid.Col md={6} lg={3}>
                    <Text size={14} weight={600} color="#262930" pb={5}>
                      Last name
                    </Text>
                    <Input<any> placeholder="Enter Last name" />
                  </Grid.Col> */}
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        NPI
                      </Text>
                      <Input<any>
                        type="number"
                        required={true}
                        error={error?.npi}
                        value={formData.provider.npi}
                        validation={(val: any) => val.length > 0}
                        onChange={(e: any) => setFormData({ ...formData, provider: { ...formData.provider, npi: e.target.value } })}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                        placeholder="Enter NPI number" />
                      {error?.npi && <Text color="red">{error?.npi}</Text>}
                    </Grid.Col>
                    {/* <Grid.Col md={6} lg={3}>
                    <Text size={14} weight={600} color="#262930" pb={5}>
                      Group NPI
                    </Text>
                    <Input<any> placeholder="Enter group NPI number" />
                  </Grid.Col> */}
                  </Grid>
                </Box>

                <Box className={classes.box}>
                  {/* service type */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Service Type
                  </Text>
                  <Grid >
                    <Grid.Col md={6} lg={6}>
                      <Select
                        placeholder="Select service type "
                        searchable
                        required={true}
                        nothingFound="No options"
                        value={formData.serviceType.id}
                        onChange={(id: string) => setFormData({ ...formData, serviceType: { id } })}
                        data={selectedServiceTypeMap}
                      />
                    </Grid.Col>
                  </Grid>
                </Box>
                <Box className={classes.box}>
                  {/* Miscellaneous */}
                  <Text size={18} weight={600} color="#262930" pb={16}>
                    Miscellaneous{" "}
                  </Text>
                  <Grid>
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        From Date
                      </Text>
                      <DateInput
                        value={formData.miscellaneous.fromDate}
                        required={true}
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        onChange={(dat: DateValue) => setFormData({ ...formData, miscellaneous: { ...formData.miscellaneous, fromDate: dat } })}
                        placeholder="mm/dd/yyyy"
                        // maw={600}
                        mx="auto"
                        rightSection={rightsection}
                      />
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        To Date
                      </Text>
                      <DateInput
                        value={formData.miscellaneous.toDate}
                        required={true}
                        onChange={(dat: DateValue) => setFormData({ ...formData, miscellaneous: { ...formData.miscellaneous, toDate: dat } })}
                        placeholder="mm/dd/yyyy"
                        // maw={600}
                        mx="auto"
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        rightSection={rightsection}
                      />
                    </Grid.Col>
                    {/* <Grid.Col md={6} lg={3}>
                    <Text size={14} weight={600} color="#262930" pb={5}>
                      MRN/patient Account
                    </Text>
                    <Input<any> placeholder="Enter  MRN account" />
                  </Grid.Col> */}
                  <Grid.Col md={6} lg={6}>
                      <Text size={14} weight={600} color="#262930" pb={5}>
                        Place of Service
                      </Text>
                      <Select
                        placeholder="Enter place of service"
                        required={true}
                        searchable
                        nothingFound="Nothing found"
                        data={locationMap}
                        value={formData.miscellaneous.placeOfService}
                        onChange={(id: string) => setFormData({ ...formData, miscellaneous: { ...formData.miscellaneous, placeOfService: id } })}
                      />
                    </Grid.Col>
                  </Grid>
                 
                </Box>
                <Flex direction={"row"} justify={"flex-end"} gap={24} pt={32}>
                  <Button variant="outline" onClick={() => setFormData(initForm)}>Clear</Button>
                  <Button type='submit'>Verify</Button>
                </Flex>
              </Box>
            </Box>
          </Paper>
        </form>
      )}
      {showInfoModal && (
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowModal}
        />
      )}
    </>

  );
};
